export enum PRODUCT_PATHS {
  AVA_ID = "id",
  AVA_INCOME = "in",
  AVA_REVIEW = "r",
}

export enum STEPS {
  UPLOAD_DOCUMENT_FRONT = "upload_document_front",
  UPLOAD_DOCUMENT_BACK = "upload_document_back",
  UPLOAD_SELFIE_BASIC = "upload_selfie_basic",
  UPLOAD_SELFIE_LIVENESS = "upload_selfie_liveness",
  DONE = "complete",
}

export enum TEMPLATE_TYPES {
  FRONT = "Front",
  FRONT_BACK = "FrontBack",
  FRONT_SELFIE = "FrontSelfie",
  FRONT_BACK_SELFIE = "FrontBackSelfie",
  FRONT_SELFIE_LIVENESS = "FrontSelfieLiveness",
  FRONT_BACK_SELFIE_LIVENESS = "FrontBackSelfieLiveness",
}

export enum IMAGE_SUBJECTS {
  DOCUMENT_FRONT = "idFront",
  DOCUMENT_BACK = "idBack",
  SELFIE_FRONT = "selfie",
  SELFIE_LEFT = "selfie_left",
  SELFIE_RIGHT = "selfie_right",
}

export enum ISSUES {
  TEXT_UNREADABLE = "no_text_detected",
  NO_FACE_ON_ID_DETECTED = "no_face_on_id_detected",
  INCOMPLETE_BARCODE_DETECTED = "incomplete_barcode_detected",
  UNSUPPORTED_ID_TYPE = "unsupported_id_type",
  BAD_SELFIE = "bad_selfie",
  INVALID_TOKEN = "invalid client token",
  TRANSACTION_ALREADY_COMPLETED = "Cannot upload images for a transaction that has already been completed.",
  BAD_UPLOAD = "bad_upload",
}

export enum HANDOFF_METHODS {
  PHONE = "phone",
  EMAIL = "email",
}

export const LikelihoodMap: [number, string][] = [
  [650, "High"],
  [0, "Probable"],
];